import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

import type { Maybe } from '../../resources/@types/accountSchema';
import { type RequestOptions, accountFetcher } from '../../resources/Fetcher';
import type { ClientRefererObject } from '../utils/refererObject';

export type V1UserCollectInfoVariables = ClientRefererObject;

export interface V1UserCollectInfoResponse {
  data: Maybe<object>;
}

export function useV1UserCollectCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    V1UserCollectInfoResponse,
    unknown,
    V1UserCollectInfoVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    V1UserCollectInfoResponse,
    unknown,
    V1UserCollectInfoVariables,
    TContext
  >((variables) => accountFetcher.post(url, variables, requestOptions), options);

  return { ...result, data: result.data?.data };
}

const API_END_POINT = '/client/api/v1/user/collect-info';

/**
 * 유입경로(referer / utm / browser / os) 수집.
 *
 * 레거시 모놀리스(ant-man `POST /api/v1/user/collect-info`)에서 account 로 이관했다.
 * 같은 테이블(`users_access_referer`)의 갱신(TRY_SIGNUP → SIGNUP)을 이미 account 가
 * 담당하고 있어, 생성도 그쪽으로 모았다.
 *
 * account 는 응답에 생성된 기록 id 를 담지만 호출부는 쓰지 않는다(로그인 시 기록만 남긴다).
 * 회원가입 플로우가 `signup/verify` 로 넘기는 id 는 이 API 가 아니라 signup 응답에서 온다.
 */
export function useUserCollectInfoCreateMutation(
  options?: Parameters<typeof useV1UserCollectCreateMutation>[0]['options'],
) {
  return useV1UserCollectCreateMutation({
    url: API_END_POINT,
    options,
  });
}
